// components/WelcomeModal.js

import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Tag,
  Text,
  useColorMode,
  useColorModeValue
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import React, { useContext } from "react";
import { UserContext } from "../UserContext";

const WelcomeModal = ({ isOpen, onClose }) => {
  const iconStrokeColor = useColorModeValue("#545454", "#545454");
  const lightModeColor = "rgba(0, 0, 0, 1)"; // Black for light mode
  const darkModeColor = "rgba(255, 255, 255, 1)"; // White for dark mode
  const transparentColor = "rgba(0, 0, 0, 0)"; // Transparent for light mode

  const userName = useContext(UserContext).userDetails.firstName;

  const { colorMode } = useColorMode();

  const icon = {
    hidden: {
      pathLength: 0,
      fill: colorMode === "light" ? transparentColor : transparentColor,
      stroke: colorMode === "light" ? lightModeColor : darkModeColor,
      strokeWidth: 0.5,
      strokeOpacity: 1,
    },
    visible: {
      pathLength: 1,
      fill: colorMode === "light" ? lightModeColor : darkModeColor,
      stroke: iconStrokeColor,
      strokeWidth: 0.5,
      strokeOpacity: 1,
    },
    transition: {
      pathLength: { duration: 1, ease: "easeInOut" },
      fill: { duration: 1, delay: 1 },
      strokeOpacity: [
        { duration: 0.5, delay: 1, from: 1, to: 0 },
        { duration: 0, delay: 0.5, to: 1 },
      ],
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      justifyContent="center"
      isCentered
      size="2xl"
      scrollBehavior="inside"
      p={6}
      m={2}
    >
      <ModalOverlay />
      <ModalContent
        rounded="2xl"
        bg={useColorModeValue("white", "oleniumBlack.600")}
        marginLeft={16}
        marginRight={16}
      >
        <ModalCloseButton />
        <ModalHeader
          justifyContent={"center"}
          alignItems={"center"}
          display={"flex"}
          flexDirection={"column"}
          mt={10}
        >
          <Tag
            variant="outline"
            mb={10}
            position={"absolute"}
            top={"15%"}
            right="30%"
            rounded={"full"}
            size={"sm"}
          >
            Beta
          </Tag>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 454 164"
            width="300px"
            height="109px"
          >
            <motion.path
              key="76324557657"
              d="M0 40H454"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="765797657"
              d="M0 123H454"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="765798765657"
              d="M40 163V0"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7657870657"
              d="M122 163V0"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="765457657"
              d="M129 163V0"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7679857657"
              d="M137 163V0"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />

            <motion.path
              key="7653467657"
              d="M144 163V0"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7679657657"
              d="M197 163V0"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7656857657"
              d="M204 163V0"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7665857657"
              d="M212 163V0"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="76556477657"
              d="M253 163V0"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7657234657"
              d="M275 163V0"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7651347657"
              d="M283 163V0"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="73254657657"
              d="M315 164V1"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="763257657"
              d="M323 164V1"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />

            <motion.path
              key="76345657657"
              d="M330 164V1"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7634657657"
              d="M339 164V1"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7656587657"
              d="M368 164V1"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7658657657"
              d="M377 164V1"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="763456757657"
              d="M406 164V1"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7435657657"
              d="M414 164V1"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="754323556067"
              d="M80.6162 39.686C89.7263 39.6599 96.3566 42.4964 97.6705 43.0794C99.8631 44.0452 105.806 46.8992 111.357 53.0161C115.29 57.3493 117.379 61.5085 118.301 63.5445C118.988 65.0498 121.668 71.2363 121.912 79.8331C122.182 89.7089 119.075 97.0179 118.049 99.2541C116.7 102.204 113.219 109.521 105.18 115.386C101.038 118.405 96.2261 120.581 90.7095 121.86C77.5882 124.888 65.3631 122.591 54.7216 113.985C47.1864 107.894 42.4616 99.985 40.617 90.4746C38.7027 80.5814 40.4517 72.7416 41.0172 70.6186C41.6959 67.9995 43.3231 62.7875 47.169 57.2101C50.8147 51.9024 54.7129 48.7961 55.7744 47.9869C57.5668 46.5947 62.1872 43.2795 69.0524 41.2957C70.4271 40.8954 74.7864 39.7121 80.6162 39.6947V39.686ZM112.88 81.5124C112.941 76.8399 112.053 72.2544 110.235 67.8603C103.892 52.4941 88.2123 44.4716 71.8106 48.944C62.3699 51.5195 55.7831 57.6364 51.7458 66.4942C48.6569 73.2724 48.0565 80.39 49.2833 87.6728C50.4058 94.3553 53.2511 100.255 57.941 105.162C65.3979 112.976 74.6994 115.952 85.2452 114.594C96.4958 113.15 104.501 106.885 109.548 96.8003C111.932 92.0321 112.941 86.9245 112.871 81.5037L112.88 81.5124Z"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7658987"
              d="M414.044 122.93C413.557 122.93 413.078 122.991 412.626 122.93C409.25 122.399 406.3 119.197 406.031 115.786C405.978 115.108 405.996 114.42 405.996 113.741C405.996 106.171 405.996 98.6015 405.996 91.0402C405.996 88.3689 405.752 85.7238 404.838 83.1917C404.403 81.9823 403.855 80.7902 403.203 79.6852C401.384 76.6398 398.643 74.9169 395.18 74.2469C392.657 73.7597 390.16 73.7858 387.68 74.3688C384.878 75.03 382.511 76.457 380.632 78.6497C378.343 81.3036 376.96 84.3751 376.56 87.8555C376.29 90.1788 376.264 91.9451 376.281 92.5455C376.377 95.8084 376.342 103.753 376.264 114.89C376.116 115.76 375.524 118.597 372.984 120.833C371.078 122.504 369.033 122.999 368.094 123.165C368.007 113.915 368.059 107.912 368.128 104.04C368.198 99.985 368.128 95.9302 368.128 91.8755C368.128 90.579 368.102 89.2825 368.024 87.9948C367.876 85.5845 367.258 83.2961 366.197 81.1296C364.265 77.1792 361.185 74.7342 356.808 74.0468C354.85 73.7336 352.867 73.7075 350.909 74.0903C346.715 74.9169 343.6 77.3011 341.355 80.8685C339.006 84.61 338.658 88.2297 338.536 89.9438C338.457 90.9619 338.475 91.8146 338.501 92.3975C338.492 99.8979 338.475 107.398 338.466 114.899C338.466 115.429 338.405 118.518 335.891 120.903C333.559 123.113 330.757 123.174 330.156 123.174V66.0244H338.423V76.2917C339.319 75.0736 340.641 73.4812 342.443 71.8367C343.922 70.488 345.296 69.2003 347.411 68.1474C350.552 66.5725 354.076 66.0331 357.87 66.2941C359.497 66.4072 361.115 66.6682 362.681 67.1642C367.032 68.5303 370.356 71.2015 372.766 75.0474C373.166 75.6739 373.523 76.3352 373.984 77.1183C375.794 74.5254 377.691 72.7329 379.092 71.5844C380.423 70.4967 382.268 69.0002 385.113 67.8777C387.114 67.0859 389.255 66.616 391.526 66.4768C394.258 66.3115 396.981 66.3637 399.653 67.025C405.23 68.3998 409.224 71.7497 411.782 76.8573C413.27 79.8244 413.975 83.0003 414.192 86.298C414.262 87.3161 414.244 88.3428 414.244 89.3695C414.244 99.8022 414.244 110.235 414.244 120.659C414.227 121.39 414.323 122.147 414.053 122.947L414.044 122.93Z"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              d="M196.89 96.9744C188.354 97.0179 179.818 97.0614 171.282 97.1049C170.838 97.1136 168.106 97.1397 166.018 94.947C164.191 93.0328 164.104 90.727 164.095 90.1962H188.528C188.502 88.8301 188.31 86.7766 187.466 84.4534C186.396 81.4863 184.821 79.5721 184.29 78.9456C182.254 76.5789 180.096 75.4042 179.392 75.0388C178.948 74.8126 177.016 73.838 174.258 73.4117C168.35 72.4894 163.564 74.8387 162.868 75.1867C155.899 78.7194 153.697 85.4454 153.253 86.794C152.244 89.883 152.235 92.5368 152.235 94.3031C152.235 96.4262 152.227 100.037 153.793 103.744C156.569 110.322 163.347 114.899 170.003 115.691C173.988 116.16 177.216 115.195 177.904 114.986C180.175 114.298 182.167 113.254 183.864 111.819C185.604 110.348 186.805 108.477 187.24 107.816C187.579 107.303 187.84 106.85 188.023 106.537C189.137 107.007 190.277 107.52 191.451 108.068C192.609 108.617 193.722 109.165 194.784 109.722C194.479 110.374 194.288 110.879 194.027 111.34C191.034 116.465 186.605 119.867 181.027 121.642C164.939 126.767 148.503 117.866 144.822 101.142C142.708 91.5362 144.796 82.7045 151.287 75.1519C155.472 70.2793 160.754 67.0946 167.184 66.3115C174.293 65.4414 181.062 66.4856 186.962 70.958C190.712 73.8032 193.227 77.5534 194.854 81.9301C197.003 87.7251 196.977 93.9116 196.942 96.1913C196.933 96.5132 196.924 96.7917 196.916 96.9831L196.89 96.9744Z"
              key="7654654"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              d="M323.135 66.0069V123.156H314.982V112.61C314.207 113.872 313.033 115.508 311.336 117.152C309.178 119.232 307.168 120.354 306.655 120.641C302.826 122.73 299.32 123.034 297.727 123.156C293.977 123.443 291.054 122.756 289.783 122.417C288.086 121.955 285.311 121.172 282.5 118.945C280.012 116.978 278.115 114.342 276.74 111.088C275.339 107.764 274.878 104.266 274.869 100.698C274.835 92.5193 274.861 84.349 274.861 76.1699C274.861 72.1586 274.861 67.9908 274.861 67.9908C274.861 67.1555 274.861 66.4681 274.861 66.0156C275.557 66.0765 276.566 66.2419 277.697 66.703C278.533 67.0424 280.377 67.8081 281.674 69.7049C282.405 70.7752 282.848 72.0542 282.97 73.5769C283.031 74.3252 283.014 75.0735 283.014 75.8218C283.014 83.3135 283.014 90.8139 283.014 98.3056C283.014 100.829 283.266 103.335 284.084 105.754C286.042 111.575 290.21 115.073 296.805 115.56C298.989 115.725 301.164 115.612 303.279 114.934C305.802 114.133 307.89 112.924 309.578 111.349C312.954 108.199 313.981 104.501 314.399 102.917C314.964 100.742 315.025 98.8625 314.99 97.6008C314.99 89.6219 314.973 81.6429 314.964 73.6726C315.043 72.8721 315.373 70.7752 317.027 68.887C319.341 66.2419 322.517 66.033 323.126 65.9982L323.135 66.0069Z"
              key="5746876"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              d="M252.56 123.147C251.733 123.13 249.688 122.956 247.731 121.52C246.086 120.311 245.346 118.84 245.164 118.449C244.424 116.883 244.398 115.456 244.398 114.838C244.294 95.5038 244.398 91.9364 244.398 91.9364C244.415 91.1446 244.398 89.2651 244.059 86.8462C243.858 85.4453 243.519 84.027 243.014 82.7044C240.935 77.3532 236.924 74.4645 231.268 73.925C229.519 73.7597 227.7 73.7597 225.978 74.0729C223.393 74.5341 221.201 75.4651 219.373 76.7964C215.362 79.7112 213.927 83.7225 213.396 85.3235C212.543 87.8816 212.413 90.1178 212.439 91.5361C212.5 102.569 212.439 110.948 212.404 114.986C212.404 115.76 212.395 117.422 211.403 119.049C210.263 120.946 208.375 121.851 207.679 122.182C206.296 122.852 205.034 123.06 204.233 123.147C204.233 122.782 204.242 115.012 204.251 114.646C204.294 91.4578 204.32 82.4695 204.251 70.0617C204.251 68.1909 204.233 66.7117 204.233 65.9982H212.439C212.439 69.5396 212.439 73.0723 212.447 76.6136C213.291 75.3346 214.614 73.603 216.528 71.8889C220.722 68.1474 225.029 66.9467 225.882 66.7204C226.926 66.442 230.363 65.6154 234.792 66.2419C236.828 66.529 240.552 67.0946 244.276 69.8441C247.887 72.5067 249.532 75.7522 250.184 77.0835C251.733 80.2594 252.325 83.6703 252.534 87.1681C252.603 88.3863 252.594 89.3086 252.586 89.6219C252.516 93.9724 252.525 104.457 252.586 120.711C252.586 121.529 252.586 122.347 252.577 123.156L252.56 123.147Z"
              key="76576547"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              d="M128.594 39.6512H136.913C136.939 67.4861 136.965 95.3124 136.991 123.147H128.664C128.664 106.476 128.647 91.0837 128.647 89.8046C128.647 79.6764 128.62 49.7706 128.603 39.6512H128.594Z"
              key="976759"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="74635567"
              d="M259.59 123.147C259.581 104.101 259.573 85.0538 259.555 65.9982H267.761C267.778 82.2868 267.787 98.5753 267.804 114.864C267.804 115.551 267.674 118.109 265.698 120.337C263.332 122.999 260.13 123.121 259.581 123.139L259.59 123.147Z"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
            <motion.path
              key="7657657"
              d="M263.523 52.3026C260.608 52.4592 257.398 49.6575 257.545 46.1509C257.659 43.4187 259.869 40.0427 263.506 40.0862C267.935 40.1384 269.979 43.7146 269.91 46.5686C269.831 49.6749 266.908 52.5985 263.523 52.3026Z"
              variants={icon}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              transition={icon.transition}
            />
          </svg>
        </ModalHeader>

        <ModalBody>
          <Text fontSize="2xl" fontWeight="bold" textAlign="center" mb={5}>
            Hello, {userName || "there"} 👋
          </Text>
          <Text
            fontSize="md"
            fontWeight="normal"
            textAlign="center"
            mb={2}
            w="80%"
            mx="auto"
          >
            Welcome to Olenium! The platform that allows you to create
            without limits and access the best talent from all over the world.
          </Text>
        </ModalBody>

        <ModalFooter justifyContent="center" mb={4}>
          <Button onClick={onClose} h="12" variant="oleniumBlue" w="200px">
            Get started
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default WelcomeModal;
